import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	useToast
} from '@chakra-ui/react';
import { useContacts, useDeleteContact } from 'hooks/contacts';

const DeleteContact = () => {
	const { toDelete, deleteModalOpen, setDeleteModalOpen } = useContacts();
	const toast = useToast();

	const [deleteContact, { loading }] = useDeleteContact({
		onSuccess: () => {
			toast({
				title: 'Contato removido com sucesso.',
				status: 'success',
				duration: 5000,
				isClosable: true
			});
			setDeleteModalOpen(false);
		},
		onError: () => {
			toast({
				title: 'Ocorreu um erro.',
				status: 'error',
				duration: 5000,
				isClosable: true
			});
		}
	});

	const onDelete = () => {
		deleteContact({
			variables: {
				where: {
					column: 'ID',
					operator: 'EQ',
					value: toDelete
				}
			}
		});
	};

	return (
		<Modal
			isCentered
			onClose={() => setDeleteModalOpen(false)}
			isOpen={deleteModalOpen}
			motionPreset="slideInBottom"
		>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Deletar Contato #{toDelete}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>Por favor, confirme a ação de exclusão.</ModalBody>
				<ModalFooter>
					<Button
						mr={3}
						variant="ghost"
						onClick={() => setDeleteModalOpen(false)}
					>
						Cancelar
					</Button>
					<Button
						isLoading={loading}
						colorScheme="red"
						onClick={onDelete}
					>
						Deletar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default DeleteContact;
